var DOM = {
  PLAY: 'event/dom/play',
  PLAYING: 'event/dom/playing',
  PAUSE: 'event/dom/pause',
  ENDED: 'event/dom/ended',
  TIMEUPDATE: 'event/dom/timeupdate',
  ERROR: 'event/dom/error',
  WAITING: 'event/dom/waiting'
};
var PLAYER = {
  QUALITY_CHANGE: 'event/player/quality-change',
  REQUEST_PLAY: 'event/player/request-play',
  PLAY_REJECTED: 'event/player/play-rejected',
  REQUEST_PAUSE: 'event/player/request-pause',
  PLAY_COUNT: 'event/player/play-count',
  PLAY_FAILED: 'event/player/play-failed',
  ENTER_FULLSCREEN: 'event/player/enter-fullscreen',
  EXIT_FULLSCREEN: 'event/player/exit-fullscreen'
};
var events =
/*#__PURE__*/
Object.freeze({
  DOM: DOM,
  PLAYER: PLAYER
});
var PLAYER$1 = {
  PLAY: 'action/player/play',
  PAUSE: 'action/player/pause',
  SET_VOLUME: 'action/player/set-volume',
  ENTER_FULLSCREEN: 'action/player/enter-fullscreen',
  EXIT_FULLSCREEN: 'action/player/exit-fullscreen'
};
var actions =
/*#__PURE__*/
Object.freeze({
  PLAYER: PLAYER$1
});
var LIB_ID = 'griffith';
/**
 * 创建一个消息管理器
 * @param id 唯一 id，传出消息会带着这个 id
 * @param targetOrigin 对应窗口的域名，不传或者传 * 表示不限制
 * @param validateId 是否验证传入消息的 id 和自身 id 相同
 */

function createMessageHelper(id) {
  var targetOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '*';
  var validateId = arguments.length > 2 ? arguments[2] : undefined;

  function subscribeMessage(handler) {
    function realHandler(event) {
      // 限制消息来源 @see https://developer.mozilla.org/zh-CN/docs/Web/API/Window/postMessage#The_dispatched_event
      var origin = event.origin || event.originalEvent.origin;
      var originIsValidated = targetOrigin === '*' || targetOrigin === origin;

      var _ref = event.data || {},
          from = _ref.from,
          incomingId = _ref.id,
          payload = _ref.payload;

      var idIsValidated = !validateId || id === incomingId;

      if (originIsValidated && from === LIB_ID && idIsValidated && payload) {
        var messageName = payload.messageName,
            data = payload.data;

        if (messageName) {
          handler(messageName, data, event.source);
        }
      }
    }

    window.addEventListener('message', realHandler);
    return {
      unsubscribe: function unsubscribe() {
        return window.removeEventListener('message', realHandler);
      }
    };
  }

  function dispatchMessage(targetWindow, messageName, data) {
    if (targetWindow && targetWindow.postMessage) {
      targetWindow.postMessage({
        from: LIB_ID,
        id: id,
        payload: {
          messageName: messageName,
          data: data
        }
      }, targetOrigin || '*');
    }
  }

  return {
    subscribeMessage: subscribeMessage,
    dispatchMessage: dispatchMessage
  };
}

export { actions as ACTIONS, events as EVENTS, createMessageHelper };